module.exports = __webpack_public_path__ + "img/Check.fbce1678.svg";